import { ADD_PENDING_REQUEST, CLEAR_PENDING_REQUESTS } from './actionTypes';

export const Cancelation = {
  cancelPendingRequests: () => (dispatch, getState) => {
    const pendingRequests = getState().requestCancellation.pendingRequests;

    pendingRequests.forEach((request) => {
      if (request.cancel) {
        request.cancel();
      }
    });

    dispatch(Cancelation.clearPendingRequests());
  },

  addPendingRequest: (payload) => ({
    type: ADD_PENDING_REQUEST,
    payload,
  }),

  clearPendingRequests: (payload) => ({
    type: CLEAR_PENDING_REQUESTS,
  }),
};
